import { render, staticRenderFns } from "./firmware.vue?vue&type=template&id=f0264f1a&"
import script from "./firmware.vue?vue&type=script&lang=js&"
export * from "./firmware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports